export const generateCartHash = (cartItems) => {
  return JSON.stringify(
    cartItems.map((i) => ({
      id: i._id,
      qty: i.quantity,
    })),
  );
};
